import { SearchableItemModelT } from "@/Common/Models/SearchableItem";
import { ValueCodeDropdownItem } from "@/Patient/Components/MedicalItems/Immunization/ValueCodeDropdownItem";

class CodeValue {
    public Code: string;
    public Label: string;

    constructor(init?: Partial<CodeValue>) {
        Object.assign(this, init);
    }

    public toCodeValueDropdownItem(isActive: boolean = false): ValueCodeDropdownItem {
        return new ValueCodeDropdownItem({
            Item: this,
            Active: isActive
        });
    }

    public ToSearchableItem(includeModels: boolean): SearchableItemModelT<CodeValue> {
        return new SearchableItemModelT<CodeValue>(this.Label, this.Code, includeModels ? this : null);
    }
}

export { CodeValue };
